<template>
  <div class="vx-row">

    <div class="vx-col w-full">
      <vx-card :title="''">

        <div id="notification-list-table" class="vx-row">
          <div class="w-full vx-col">

            <vs-table stripe sort class="mt-8" :data="tiers">
              <template slot="thead">
                <vs-th width="25%">TIER TYPE</vs-th>
                <vs-th width="25%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr @click.native="onClickUpdate(tr)" class="cursor-pointer" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>

                  <vs-td>
                    <div class="justify-start vx-row">
                      <vx-tooltip text="View/Update" position="top">
                        <vs-button @click.stop="onClickUpdate(data[indextr])" class="ml-3"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit-2"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>

                </vs-tr>
              </template>

            </vs-table>

          </div>
        </div>

      </vx-card>
    </div>
    <UpdatePricingTierPopUp ref="updatePricingTierPopUp"/>
  </div>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory';
  import UpdatePricingTierPopUp from "@/components/popups/settings/pricing-tiers/UpdatePricingTierPopUp";

  const PricingTierRepository = RepositoryFactory.get('pricing_tier');

  export default {
    name: "PricingTierSettings",
    data() {
      return {
        tiers: [],
      }
    },
    components: {
      UpdatePricingTierPopUp
    },
    methods: {
      async refreshData() {
        await this.fetchPricingTiers()
      },
      async fetchCurrencies() {
        await this.fetchPricingTiers()
      },
      async fetchPricingTiers() {
        this.$vs.loading()
        try {
          const response = (await PricingTierRepository.getPricingTierList()).data
          const data = response.data || response
          const bespoke_tiers = data['bespoke-pricing'] || {}
          const contract_tiers = data['contract-pricing'] || []
          this.tiers = [
            {
              name: 'Bespoke Pricing',
              type: 'bespoke-pricing',
              tiers: bespoke_tiers
            },
            {
              name: 'Contract Pricing',
              type: 'contract-pricing',
              tiers: contract_tiers
            }
          ]
        } catch (e) {
          console.error(e)
        } finally {
          this.$vs.loading.close()
        }
      },
      onClickUpdate(tr) {
        this.$refs.updatePricingTierPopUp.openPopup(tr)
      }
    },
    async mounted() {
      await this.fetchPricingTiers()
    }
  }
</script>

<style scoped>

</style>

